import { ObjectionLibraryManager } from "@/components/objections/ObjectionLibraryManager";
import { ObjectionMatcher } from "@/components/objections/ObjectionMatcher";

export default function Objections() {
  return (
    <div className="space-y-6">
      <div className="grid gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <ObjectionLibraryManager />
        </div>
        <div>
          <ObjectionMatcher />
        </div>
      </div>
    </div>
  );
}
